export enum VehicleElectricalClass {
    UNSPECIFIED = 'unspecified',
    ALL_ELECTRIC = 'all-electric',
    PLUGIN_HYBRID = 'plugin-hybrid',
    HYBRID = 'hybrid',
}
